<template>
  <div class="reserve-notify">
    <div>
      <div class="item">
        <span class="label">桌台类型 </span>
        <span class="center">:</span>
        <span>
          {{ getTableType(tableReservationInfo.reserveTableCategoryId) }}
        </span>
      </div>
      <div class="item">
        <span class="label">预约人 </span>
        <span class="center">:</span><span>{{ tableReservationInfo.booker }}</span>
      </div>
      <div class="item">
        <span class="label">预约时间 </span>
        <span class="center">:</span>
        <span>{{ dayjs(tableReservationInfo.startTime).format("YYYY-MM-DD HH:mm") }}</span>
      </div>
      <div class="item">
        <span class="label">联系方式 </span>
        <span class="center">:</span>
        <span>{{ tableReservationInfo.contact }}</span>
      </div>
      <div class="item">
        <span class="label">备注 </span>
        <span class="center">:</span>
        <span>{{ tableReservationInfo.bookerRemark || "无" }}</span>
      </div>
    </div>
    <footer class="footer">
      <button @click="showBookingDialog = true" class="left">查看详情</button>
      <button @click="showRejectDialog = true" class="reject">拒绝</button>
      <button @click="showEditDialog = true">同意</button>
    </footer>
    <BookingDialog v-if="showBookingDialog" v-model="showBookingDialog" />
    <EditBookingDialog
      :show="showEditDialog"
      :table-reservation-info="tableReservationInfo"
      v-if="showEditDialog"
      @update:show="showEditDialog = $event"
      @confirm="handleConfirm"
    />
    <RejectDialog
      v-if="showRejectDialog"
      :show="showRejectDialog"
      :customerReserveId="tableReservationInfo.customerReserveId || -1"
      @update:show="showRejectDialog = $event"
      @reject="handleReject"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from "vue"
import type { MerchantOmsCustomerReservation, TableReserveList } from "@/api/business/types/table"
import dayjs from "dayjs"
import { ref } from "vue"
import BookingDialog from "@/views/page/business/components/Booking/BookingDialog.vue"
import EditBookingDialog from "@/views/page/business/components/Booking/EditBookingDialog.vue"
import RejectDialog from "@/views/page/business/components/Booking/RejectDialog.vue"

// const emit = defineEmits(["refresh", "refreshTableItem"])
defineProps({
  tableReservationInfo: {
    type: Object as PropType<MerchantOmsCustomerReservation>,
    required: true,
  },
})

const emit = defineEmits(["close"])

const showBookingDialog = ref(false)
const showEditDialog = ref(false)
const showRejectDialog = ref(false)

const handleClose = () => {
  emit("close")
}

const handleReject = () => {
  showRejectDialog.value = false
  handleClose()
}

const handleConfirm = () => {
  showEditDialog.value = false
  handleClose()
}

// 获取预订桌台信息
const getTableType = (val: Array<TableReserveList>) => {
  const tableTypeList: any = []
  val.forEach((item: TableReserveList) => {
    tableTypeList.push(`${item.name}×${item.count}`)
  })
  return tableTypeList.join(" ")
}
</script>

<style scoped lang="scss">
.reserve-notify {
  width: 230px;
  margin-top: 20px;
  text-align: center;
}

.item {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  line-height: 22px;

  span.label {
    display: block;
    width: 80px;
    font-size: 14px;
    color: #0009;
    text-align-last: justify;
    letter-spacing: 4px;
  }

  .center {
    flex: 0;
    margin: 0 5px;
    text-align: left;
  }

  span {
    width: 150px;
    color: #000;
    text-align: left;
  }

  span:hover {
    cursor: default;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  button {
    width: 20%;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
    color: #0052d9;
    background-color: #fff;
    border: none;
    border-radius: 4px;
  }

  .left {
    flex: 1;
    text-align: left;
  }

  .reject {
    color: #bf0b0e;
  }
}

h2:hover,
button:hover {
  cursor: pointer;
}
</style>
